import { render, staticRenderFns } from "./RequestCancellation.vue?vue&type=template&id=82a706c0&"
import script from "./RequestCancellation.vue?vue&type=script&lang=js&"
export * from "./RequestCancellation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports